import ApiService from "../api";

export default class EasyPalletService extends ApiService {

    constructor() {
        super("/api/easypallet");
    }

    listaTrabalhada(dataInicial, dataFinal) {
        return this.get(`/lista-trabalhada?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
    }

    relatorio(dataInicial, dataFinal, filialId, funcionario) {
        return this.get(`/relatorio?dataInicial=${dataInicial}&dataFinal=${dataFinal}&filialId=${filialId || null}&funcionario=${funcionario || ""}`);
    }

    relatorioProducaoMensal(filialId, funcionario, ano) {
        return this.get(`/relatorio/producao-mensal?ano=${ano || 2026}&filialId=${filialId || null}&funcionario=${funcionario || ""}`);
    }

    listaMontadores(filialId) {
        return this.get(`/montadores/${filialId}`);
    }

}
